module.exports = __webpack_public_path__ + "static/media/loyalty.34ece779.png";